import React from "react";
import { motion } from "framer-motion";
import { Box } from "@mui/material";

interface BorderBeamProps {
  size?: number;
  duration?: number;
  colorFrom?: string;
  colorTo?: string;
  borderWidth?: number;
}

export const BorderBeam: React.FC<BorderBeamProps> = ({
  duration = 8,
  colorFrom = "#10B981",
  colorTo = "#4F46E5",
  borderWidth = 1.5,
}) => {
  return (
    <Box
      sx={{
        pointerEvents: "none",
        position: "absolute",
        inset: 0,
        borderRadius: "inherit",
        padding: `${borderWidth}px`,
        overflow: "hidden",
        zIndex: 1,
        // Crucial CSS Mask: content-box is completely excluded, leaving ONLY the perimeter border!
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
        WebkitMaskComposite: "xor",
      }}
    >
      <motion.div
        animate={{
          rotate: [0, 360],
        }}
        transition={{
          duration,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          top: "-100%",
          left: "-100%",
          width: "300%",
          height: "300%",
          background: `conic-gradient(from 0deg, transparent 0deg 300deg, ${colorFrom} 335deg, ${colorTo} 360deg)`,
        }}
      />
    </Box>
  );
};

export default BorderBeam;
